import { get, post, deletes, put } from './index'
const baseUrl = process.env.VUE_APP_TARGET

const MAP_LIST = {
  company: 'company', // 公司
  order: 'order', // 订单

  user: 'user/user', // 用户
  shop: 'user/shop', // 分店
  scene: 'user/scene', // 场景
  catalog: 'user/catalog', // 品类
  item: 'user/item', // 商品
  tabletypeconfig: 'user/food/table/type/config', // 餐桌类型配置
  tableconfig: 'user/food/table/config', // 餐桌配置
  lineUpConfig: 'user/lineUpConfig', // 排队配置
  feedback: 'user/feedback', // 反馈
  model: 'user/run/model', // 模式
  reason: 'user/reason', // 原因
  label: 'user/printer/label', // 标签
  // shop2user: 'user/shop/mapping', // 用戶 - 分店
  user2shop: 'user/shop/mapping', // 用戶 - 分店
  // scene2catalog: 'user/scene/catalog/mapping', // 场景 - 品类
  // catalog2scene: 'user/scene/catalog/mapping', // 场景 - 品类
  // item2catalog: 'user/catalog/item/mapping', // 商品 - 品类
  catalog2item: 'user/catalog/item/mapping', // 商品 - 品类
  // coupon: 'user/discount/ticket', // 优惠券

  table: 'food/table', // 餐桌
  privilege: 'privilege/mapping', // 权限
  lineUp: 'lineUp', // 排队取号
  printer: 'printer', // 打印机
  monitor: 'shop/touch/device', // 触摸屏
  audit: 'send/to/kitchen/audit', // 落单审核
  paytype: 'pay/type', // 支付方式
  reader: 'stripe/reader', // POS机
  eftReader: 'find/eftConfig', // POS机
  customTakeaway: 'take/out/setting', // 自定义外卖平台
  // level: 'vip/level', // 会员等级
  vipcost: 'vip/renew/mode', // 会员付费模式
  // scoreshop: 'score/shop', // 积分商城
  filter: 'search/template', // 筛选条件
  book: 'booking', // 预定
  charge: 'rechargeItem', // 充值
  cashReason: 'cashManagementReason', // 现金原因
  cashAction: 'cashManagement', // 现金操作
  remarkTemp: 'remark/template', // 预设备注
  reasonTemp: 'shopReasonMapping', // 预设原因
  clock: 'time/clock', // 打卡
}

// #region url处理
function url_create(str) {
  switch (str) {
    case 'company':
      return `/user/${MAP_LIST[str]}`
    case 'order':
    default:
      return `/${MAP_LIST[str]}`
  }
}
function url_delete(str) {
  switch (str) {
    case 'company':
    case 'order':
      return `/user/${MAP_LIST[str]}`
    default:
      return `/${MAP_LIST[str]}`
  }
}
function url_modify(str) {
  switch (str) {
    case 'company':
    case 'order':
      return `/user/${MAP_LIST[str]}/modify`
    default:
      return `/${MAP_LIST[str]}/modify`
  }
}
function url_search(str) {
  switch (str) {
    case 'order':
      return `/user/${MAP_LIST[str]}`
    case 'company':
    default:
      return `/${MAP_LIST[str]}`
  }
}
// function url_export(str) {
//   switch (str) {
//     case 'aaa':
//       return `/user/${MAP_LIST[str]}/export`
//     default:
//       return `/${MAP_LIST[str]}/export`
//   }
// }
// function url_import(str) {
//   switch (str) {
//     case 'aaa':
//       return `/user/${MAP_LIST[str]}/import`
//     default:
//       return `/${MAP_LIST[str]}/import`
//   }
// }
// #endregion

export default {
  baseUrl,
  url_upload_image: baseUrl + '/user/img/upload/2M',
  // url_upload_video: baseUrl + '/user/video/upload',
  // url_upload_document: baseUrl + '/user/img/upload/2M',
  url_websocket: baseUrl.replace('http', 'ws') + '/websocket/',
  // url_export: baseUrl + '/user/download/',

  util_create: (str, data) => post(url_create(str), data),
  util_modify: (str, data) => put(url_modify(str), data),
  util_delete: (str, data) => deletes(url_delete(str), data),
  util_search: (str, data) => put(url_search(str), data),
  util_query: (str) => get(url_search(str)),
  // util_export: (str, data) => put(url_export(str), data),
  // url_import: url_import,

  // 服务员
  waiter_search: shopId => put('/user/shop/waiter', { shopId }),
  // 服务员密码验证
  waiter_verify: data => put('/user/shop/employeeKey/check', data),
  // 服务员打卡状态查询
  waiter_clock_type_get: data => put('/time/clock/check', data),

  // 查询当前哪一个场景正在适合
  current_scene_search: data => put('/user/scene/ok', data),
  // 开台 拼桌
  table_create: data => put('/food/table/add', data),
  // 生成 二维码
  qrcode_create: data => put('/img/qrcode', data),
  // 查询 当前序列
  current_line_search: data => put('/lineUp/code', data),
  // 查询 指定序列
  designated_line_search: data => put('/lineUp/status', data),
  // 商品加入购物车
  cart_add: data => put('/add/order/item', data),
  // 二重密码验证
  password_verify: data => put('/user/shop/user/secondaryPassword/check', data),
  // 一鍵上下线
  online_status_tiggle: data => put('/user/catalog/item/mapping/status', data),
  // 结算 分钱
  payment_cash_enter: data => put('/user/order/enter/part/cash', data),
  // 结算 分菜
  payment_food_enter: data => put('/user/order/enter/part/food', data),
  // 结算 付款
  payment_pay_enter: data => put('/user/order/enter/one/user/pay', data),
  // 结算 撤銷
  payment_cancel: data => put('/user/order/cancel/payType', data),
  // 创建 支付订单
  payment_create: data => put(`/user/order/pay`, data),
  // 支付 支付订单
  payment_pay: data => put(`/user/order/call/back`, data),
  // 支付 余额支付订单
  payment_pay_balance: data => put(`/user/order/remaining/sum`, data),
  // 分钱
  payment_cash_config: data => put(`/user/order/part/cash`, data),
  // 订单 价格 计算
  order_cost_calc: data => put(`/order/cal/price`, data),
  // DISCOUNT_TICKET_NOT_EXIST(40, "优惠卷不存在"),
  // DISCOUNT_TICKET_TIME_NOT_MATCH(41, "优惠卷优惠时间段没有匹配上"),
  // DISCOUNT_TICKET_NOT_MATCH_AT_LEAST_COST(42, "优惠卷不满足最低消费"),
  // DISCOUNT_TICKET_CAN_USE_ONCE(43, "优惠卷不能多张同时使用"),
  // DISCOUNT_TICKET_EXPIRED(44, "优惠卷不在有效期内"),
  // 所有商品
  // items_catalog_search: data => put(`/user/catalog/item/mapping/shop`, data),
  // 清除购物车商品
  // cart_clear: data => put(`/order/clean`, data),
  // 移位
  table_move: data => put(`/food/table/move`, data),
  // 打印机
  printer_search: data => put(`/printer/status`, data),
  // 设备状态
  device_status_search: data => put(`/shop/device/status`, data),
  // 打印新开台的二维码
  print_table: (data, printerId) => put(`/printer/add/new/order/${printerId}`, data),
  
  // 打印闭店总报告
  print_report_all: (data, printerId) => put(`/printer/close/report/${printerId}`, data),
  // 打印闭店菜品报告
  print_report_dish: (data, printerId) => put(`/printer/item/close/report/${printerId}`, data),
  // 打印闭店菜品报告
  print_report_cash: (data, printerId) => put(`/printer/cash/close/report/${printerId}`, data),
  // 打印闭店详情报告
  print_report_detail: (data, printerId) => put(`/printer/detail/report/${printerId}`, data),
  // 获取当日报告
  print_report_search: data => put(`/shop/close/report`, data),
  // 获取钱箱报告
  cash_report_search: data => put(`/shop/cash/close/report`, data),
  // 获取菜品报告
  dish_report_search: data => put(`/shop/item/close/report`, data),

  // 获取订单
  order_search: data => put(`/user/order/manage`, data),
  // 打印排队信息
  print_line: (data, printerId) => put(`/printer/line/up/${printerId}`, data),
  // 打印小票
  print_order: (data, printerId) => put(`/printer/order/${printerId}`, data),
  // 打印小票 分菜
  print_order_food: (data, printerId) => put(`/printer/part/order/${printerId}`, data),
  // 发送厨房
  print_kitchen: data => put(`/send/printer`, data),
  // 发送追单
  reminder_kitchen: data => put(`/printer/send/reminder/to/kitchen`, data),
  // 订单合併
  order_merge: data => put(`/order/conbine`, data),
  // 查询失效订单数量
  order_expired_search: data => put(`/expired/order`, data),
  // 产生一个新的UUID
  uuid_create: data => post(`/shop/uuid`, data),
  // 退款
  order_refund: data => put(`/order/return/cash`, data),
  order_refund2: data => put(`/order/return/expire/order/cash`, data),
  // 清空餘量
  leftCount_clear: data => put(`/user/item/left/count`, data),
  // 查询是否有售罄
  sellOut_search: data => put(`/shop/has/sale/out`, data),
  // 取消店鋪下所有售罄
  sellOut_clear: data => put(`/shop/clean/sale/out`, data),
  // 扫描支付
  scan_pay: data => put(`/pay/code`, data),
  // 锁定菜品
  order_item_lock: data => put(`/order/lock/cash/order/item`, data),
  // 查询是否有未付款订单
  order_not_pay_search: data => put(`/user/shop/unpaid/order`, data),
  // 查询是否有未处理预定
  book_not_done_search: data => put(`/check/booking`, data),
  // 服务员手动切换打印机通知后台
  print_change: data => put(`/switch/printer`, data),
  // 结账的时候，判断余量是否足够
  order_calc_before: data => put(`/check/order/stock/available`, data),
  // 单人结账转分钱结账，绑定优惠券
  order_bind_coupon: data => put(`/order/bind/discount/ticket`, data),
  
  // 获取系统环境
  sysenv_search: () => get('/system/config'),
  // 获取图片终端地址
  aliyun_search: () => get('/img/upload'),
  // 获取版本号
  version_seach: data => put('/dola/version', data),
  // 用户登录
  user_login: data => put('/login', data),
  // 用户退出
  user_logout: () => put(`/logout`),
  // 查询登录用户是否还在登录状态
  user_login_get: () => get('/is/login'),
  // 查询登录用户信息
  // user_info_get: () => get('/user/userInfo'),
  // 修改用户自己的密码
  // psd_modify_mine: (oldPassword, password) => post('/user/password', { oldPassword, password }),
  // 修改其它用户的密码
  // psd_modify_other: (id, password) => put('/user/otherUser/password', { id, password }),
  
  // 订单可用优惠券
  order_coupon_get: data => put(`/customer/available/ticket`, data),
  // 订单可用优惠券2
  order_coupon_change: data => put(`/customer/check/ticket/list`, data),
  // 生成VIP开通订单
  payment_vip_create: data => put(`/user/order/vip`, data),
  // 生成会员余额充值订单
  payment_balance_create: data => put(`/user/recharge/order/pay`, data),
  // 查询登录用户信息
  user_info_get: data => put('/customer', data),
  // 用户修改
  // user_info_modify: data => put('/customer/modify', data),
  // 用户的优惠券
  // user_coupon_get: data => put('/customer/ticket', data),

  // 创建子订单
  sub_order_create: data => put('/user/sub/order', data),
  // 移动子订单菜品
  sub_order_move_food: data => put('/user/move/item/to/sub/order', data),

  // 判断是否显示落单审核按钮，参数是id或者shopId
  orderNew_show: data => put('/shop/show/send/to/kitchen/audit', data),
  // 落单审核细节修改,传ID,shopId, orderId以及对应的修改
  orderNew_set: data => put('/send/to/kitchen/audit/item/modify', data),
  
  // #region stripe
  // 获取连接的token,参数传shopId,以表示获取的是这一个分店的token
  stripe_token: data => post('/stripe/terminal/connection/token', data),
  // 获取订单支付信息,传id(一定是支付订单的ID，需要还涉及到)shopId
  stripe_secret: data => post('/stripe/terminal/payment/intent', data),
  // 捕获支付信息，传id,以及shopId
  stripe_intent: data => post('/stripe/terminal/capture/payment/intent', data),
  // #endregion
  
  // 支持修改支付方式的支付渠道
  payway_change_search: data => put('/pay/type/non/third/party', data),

  // 已发送厨房的菜品转台
  dish_move: data => put('/dish/move', data),

  // 查询会员的余额历史, customerId一定要传
  balance_history_search: data => put('/customer/remaining/sum/history', data),

  // 开店闭店专用
  shop_status_change: data => put('/shop/status/modify', data),

  // debug
  debug: data => put('/js/debug', data),
  // type: 1eft 2ws

  // 获取预定日期
  book_date_get: data => put('/find/book/date', data),
  // 获取指定某日的预定时间段
  book_date_time_get: data => put('/find/book/time', data),
  // 取消预定
  book_cancel: data => put('/booking/cancel', data),

  // 二维码查询
  qrcode_get: data => put('/pos/qr/last/open/config', data),
  // 二维码设置
  qrcode_set: data => put('/pos/qr/open/config', data),
}